import React from 'react';
import { create } from 'jss';
import preset from 'jss-preset-default';
import { createGenerateClassName, StylesProvider, jssPreset } from '@material-ui/styles';
import styles from 'src/styles';

const jss = create({
  ...jssPreset(),
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  // insertionPoint: document.getElementById('jss-insertion-point'),
  plugins: preset().plugins,
});

jss.createStyleSheet(styles, { meta: 'global' }).attach();

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true,
});

const jssProvider = ({ children, ...others }) => (
  <StylesProvider jss={jss} generateClassName={generateClassName} {...others}>
    {children}
  </StylesProvider>
);

export default jssProvider;
